import store from "store";

export const useStorage = (key: string) => {
  const set = <T>(arg: T) => store.set(key, arg);
  const get = () => store.get(key);
  const remove = () => store.remove(key);

  return { get, set, remove };
};
